/* eslint-disable max-len */
import React from 'react';
import { Switch } from 'react-router-dom';
import { compose, withProps, branch, renderComponent } from 'recompose';
import { PAGE_TYPES, PAGE_SUB_TYPES } from '@sparefoot/tracking-events';
import { RouteWithQueryAndProps as SFRoute } from 'decorators';
import { connect } from 'react-redux';
import { removeUrlParam } from 'lib/helpers';
// Import Code Split Bundles
import {
	HomePage,
	FacilityPage,
	BookingConfirmation,
	PSPPage,
	MovingTruckCLPPage,
	UnitPage,
	LegalConsumerPage,
	LegalGiftCardTermsPage,
	LegalConsumerPrivacyPage,
	LegalConsumerPaymentPage,
	LegalClientLTVPage,
	LegalReviewsPage,
	NewFourOhFourPage,
	UnsubscribePage,
	SizeGuidePage,
	StateLandingPage,
	MovingTruckPage,
	MovingSuppliesPage,
	PortableStoragePage,
	ReviewPage,
	SearchPage,
	SearchPageWrapper,
	RebateClaimPage,
	RebateStatusPage,
	MoveInConfirmStatusPage,
	MoveInIncentivePage,
	VehicleLengthPage,
	PaidTemplatePage,
	EmailAuthPage,
	OMIPage,
	StyleGuidePage,
} from 'pages/Bundles';

// Import Page Actions
import {
	getBookingPage,
	getHomepage,
	getUnsubscribePage,
	getLegalPage,
	getRebateClaimPage,
	getRebateStatusPage,
	getMoveInIncentivePage,
	getMovingSuppliesPage,
	getPortableStorageCityLandingPage,
	getUnitPage,
	getStateLandingPage,
	getReviewPage,
	getSupplementalReviewData,
	getPSPLandingPage,
	getMovingTruckPage,
	getMovingTruckCityLandingPage,
	getMoveInConfirmStatusPage,
	vehicleLengthPageSuccess,
	getPaidTemplatePage,
} from 'store/pages/actions';

import { getFacilityPage } from 'store/facilities/actions';

import {
	getSearchPage,
	getCityLandingPage,
	getNearMePages,
	getVehicleLandingPage,
	getAmenityLandingPage,
	getNeighborhoodLandingPage,
	getFiveByFiveLandingPage,
	getTenByTenLandingPage,
	getFiveByTenLandingPage,
	getFiveByFifteenLandingPage,
	getTenByFifteenLandingPage,
	getTenByTwentyLandingPage,
	getTenByTwentyFiveLandingPage,
	getTenByThirtyLandingPage,
	getMiniStorageLandingPage,
} from 'store/search/actions';

export const staticRoutes = [
	{
		path: '/',
		exact: true,
		component: HomePage,
		actions: { getHomepage },
		loadData: (props) => props.actions.getHomepage(),
	},
	{
		path: '/unsubscribe(.html)?',
		exact: true,
		actions: { getUnsubscribePage },
		component: UnsubscribePage,
		loadData: (props) => props.actions.getUnsubscribePage(),
	},
	{
		path: '/reservation/(cancellation|confirmation)/:confirmationCode([A-Za-z0-9]+)(.html)?',
		exact: true,
		actions: { getBookingPage },
		component: compose(
			connect((state) => ({
				statusCode: state.pageMeta.statusCode,
			})),
			branch(
				(props) => [401, 403].includes(props.statusCode), // Unauthorized or forbidden booking
				compose(
					withProps((props) => {
						const { email, ...restQueryParams } =
							props.queryParams || {};
						// Update URL to remove email param
						if (email) {
							removeUrlParam('email');
						}
						return {
							queryParams: restQueryParams,
						};
					}),
					renderComponent(EmailAuthPage)
				)
			)
		)(BookingConfirmation),
		loadData: (props) =>
			props.actions.getBookingPage(
				props.match.params.confirmationCode,
				props.queryParams
			),
	},
	{
		path: '/reservation/online-move-in/:confirmationCode([A-Za-z0-9]+)',
		actions: { getBookingPage },
		exact: true,
		component: OMIPage,
		loadData: (props) =>
			props.actions.getBookingPage(
				props.match.params.confirmationCode,
				props.queryParams
			),
	},
	{
		path: '/legal/consumer(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalConsumerPage,
		loadData: (props) => props.actions.getLegalPage('legal'),
	},
	{
		path: '/legal/gift-card-terms(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalGiftCardTermsPage,
		loadData: (props) => props.actions.getLegalPage('legal'),
	},
	{
		path: '/legal/privacy(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalConsumerPrivacyPage,
		loadData: (props) => props.actions.getLegalPage('legal'),
	},
	{
		path: '/legal/:pageType(client|ltv)(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalClientLTVPage,
		loadData: (props) => props.actions.getLegalPage('legal'),
	},
	{
		path: '/legal/:pageType(client|ltv)/:version([0-9]+)(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalClientLTVPage,
		loadData: (props) => props.actions.getLegalPage('legal'),
	},
	{
		path: '/legal/consumer/payment(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalConsumerPaymentPage,
		loadData: (props) => props.actions.getLegalPage('legal'),
	},
	{
		path: '/legal/reviewstoc(.html)?',
		exact: true,
		actions: { getLegalPage },
		component: LegalReviewsPage,
		loadData: (props) => props.actions.getLegalPage('reviewstoc'),
	},
	{
		path: '/rebate(.html)?',
		exact: true,
		component: RebateClaimPage,
		actions: { getRebateClaimPage },
		loadData: (props) => props.actions.getRebateClaimPage(),
	},

	{
		path: '/rebate/status(.html)?',
		exact: true,
		component: RebateStatusPage,
		actions: { getRebateStatusPage },
		loadData: (props) => props.actions.getRebateStatusPage(),
	},
	{
		path: '/rebate/move-in/:confirmationCode([A-Za-z0-9]+)/:offerId([A-Za-z0-9]+)(.html)?',
		exact: true,
		component: MoveInIncentivePage,
		actions: { getMoveInIncentivePage },
		loadData: (props) =>
			props.actions.getMoveInIncentivePage(
				props.match.params.confirmationCode,
				props.match.params.offerId
			),
	},
	{
		path: '/moving-supplies(.html)?',
		exact: true,
		actions: { getMovingSuppliesPage },
		component: MovingSuppliesPage,
		loadData: (props) => props.actions.getMovingSuppliesPage(),
	},
	{
		path: '/storage-unit-size-guide(.html)?',
		exact: true,
		actions: { getPSPLandingPage },
		component: SizeGuidePage,
		loadData: (props) => props.actions.getPSPLandingPage('size'),
	},

	{
		path: '/portable-storage/:city([A-Za-z0-9-\\.]+)-:state([A-Za-z]{2})(.html)?',
		exact: true,
		actions: { getPortableStorageCityLandingPage },
		component: PortableStoragePage,
		loadData: (props) =>
			props.actions.getPortableStorageCityLandingPage(
				props.match.params.city,
				props.match.params.state
			),
	},
	{
		path: '/facility/:facilityId(\\d{3,})/unit/:unitId(\\d{3,})(.html)?',
		exact: true,
		actions: { getUnitPage },
		component: UnitPage,
		loadData: (props) =>
			props.actions.getUnitPage(
				props.match.params.unitId,
				props.match.params.facilityId
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/*-:facilityId(\\d{3,})(/reserve)?/:unitId(\\d+)(.html)?',
		exact: true,
		actions: { getUnitPage },
		component: UnitPage,
		loadData: (props) =>
			props.actions.getUnitPage(
				props.match.params.unitId,
				props.match.params.facilityId
			),
	},
	{
		path: '/search(.html)?',
		exact: true,
		actions: { getSearchPage },
		component: SearchPageWrapper,
		pageType: PAGE_TYPES.SEARCH,
		key: 'search',
		loadData: (props) => props.actions.getSearchPage(props.queryParams),
	},
	{
		path: '/near-me/:keyword(rv-storage|car-storage|climate-controlled-storage|boat-storage|portable-storage|motorcycle-storage|business-storage|wine-storage|atv-storage|bicycle-storage|dirt-bike-storage|golf-cart-storage|college-storage|truck-storage|jet-ski-storage|kayak-storage|military-storage|drive-up-storage|24-hour-storage|vehicle-storage|mini-storage|5x5-storage|5x10-storage|5x15-storage|10x10-storage|10x15-storage|10x20-storage|10x25-storage|10x30-storage|locker-storage|storage-with-electricity|storage-deals|storage-with-free-truck-rental)(.html)?',
		exact: true,
		actions: { getNearMePages },
		component: SearchPageWrapper,
		pageType: PAGE_SUB_TYPES.STORAGE_NEAR_ME_LANDING,
		key: 'near-me',
		loadData: (props) =>
			props.actions.getNearMePages(props.match.params, props.queryParams),
	},
	{
		path: '/review(.html)?',
		exact: true,
		actions: { getReviewPage, getSupplementalReviewData },
		component: ReviewPage,
		loadData: (props) =>
			Promise.all([
				props.actions.getReviewPage(),
				props.actions.getSupplementalReviewData(props.queryParams),
			]),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage(.html)?',
		exact: true,
		actions: { getCityLandingPage },
		component: SearchPageWrapper,
		pageType: PAGE_TYPES.CITY_LANDING,
		key: 'search',
		loadData: (props) =>
			props.actions.getCityLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/:vehicle(car|boat|rv)-storage(.html)?',
		exact: true,
		actions: { getVehicleLandingPage },
		component: SearchPageWrapper,
		pageType: PAGE_SUB_TYPES.VEHICLE_LANDING,
		key: 'search',
		loadData: (props) =>
			props.actions.getVehicleLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/:amenity(climate-controlled|24-hour-access|drive-up-storage-units|wine-storage|storage-lockers|storage-with-electricity|storage-with-free-truck-rental)(.html)?',
		exact: true,
		actions: { getAmenityLandingPage },
		component: SearchPageWrapper,
		pageType: PAGE_SUB_TYPES.AMENITY_LANDING,
		key: 'search',
		loadData: (props) =>
			props.actions.getAmenityLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/5x5-storage-units(.html)?',
		exact: true,
		actions: { getFiveByFiveLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_5x5_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getFiveByFiveLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/10x10-storage-units(.html)?',
		exact: true,
		actions: { getTenByTenLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_10x10_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getTenByTenLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/5x10-storage-units(.html)?',
		exact: true,
		actions: { getFiveByTenLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_5x10_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getFiveByTenLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/5x15-storage-units(.html)?',
		exact: true,
		actions: { getFiveByFifteenLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_5x15_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getFiveByFifteenLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/10x15-storage-units(.html)?',
		exact: true,
		actions: { getTenByFifteenLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_10x15_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getTenByFifteenLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/10x20-storage-units(.html)?',
		exact: true,
		actions: { getTenByTwentyLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_10x20_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getTenByTwentyLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/10x25-storage-units(.html)?',
		exact: true,
		actions: { getTenByTwentyFiveLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_10x25_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getTenByTwentyFiveLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/10x30-storage-units(.html)?',
		exact: true,
		actions: { getTenByThirtyLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_10x30_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getTenByThirtyLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/mini-storage(.html)?',
		exact: true,
		actions: { getMiniStorageLandingPage },
		component: SearchPageWrapper,
		pageType: 'city_mini_storage_landing_page',
		key: 'search',
		loadData: (props) =>
			props.actions.getMiniStorageLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/*-:facilityId(\\d{3,})(.html)?',
		exact: true,
		actions: { getFacilityPage, getHomepage },
		component: FacilityPage,
		loadData: (props) =>
			Promise.all([
				props.actions.getFacilityPage(
					props.match.params.facilityId,
					props.match.params.city,
					props.match.params.state
				),
				props.actions.getHomepage(),
			]),
	},
	{
		path: '/(facility|facilities)/:facilityId(\\d{3,})(.html)?',
		exact: true,
		actions: { getFacilityPage, getHomepage },
		component: FacilityPage,
		loadData: (props) =>
			Promise.all([
				props.actions.getFacilityPage(props.match.params.facilityId),
				props.actions.getHomepage(),
			]),
	},
	{
		path: '/:city-:state([A-Za-z]{2})-self-storage/:neighborhood([A-Za-z-0-9]+)(.html)?',
		exact: true,
		actions: { getNeighborhoodLandingPage },
		component: SearchPageWrapper,
		pageType: PAGE_SUB_TYPES.NEIGHBORHOOD_LANDING,
		key: 'search',
		loadData: (props) =>
			props.actions.getNeighborhoodLandingPage(
				props.match.params,
				props.queryParams
			),
	},
	// PSPs - Dynamic route for all storage type pages
	{
		path: '/:keyword(rv|car|climate-controlled|boat|portable|motorcycle|business|wine|atv|bicycle|dirt-bike|golf-cart|college|truck|jet-ski|kayak|military|drive-up|24-hour|vehicle)-storage(.html)?',
		exact: true,
		component: PSPPage,
		actions: { getPSPLandingPage },
		loadData: async ({ actions, match }) => {
			const keyword = match.params.keyword || '';
			return actions.getPSPLandingPage(keyword);
		},
	},
	{
		path: '/storage-unit-size-guide/:keyword(mini-storage)(.html)?',
		exact: true,
		component: PSPPage,
		actions: { getPSPLandingPage },
		loadData: async ({ actions, match }) => {
			const keyword = match.params.keyword || '';
			return actions.getPSPLandingPage(keyword);
		},
		keyword: 'mini storage',
	},
	{
		path: '/storage-unit-size-guide/:keyword(storage-lockers)(.html)?',
		exact: true,
		component: PSPPage,
		actions: { getPSPLandingPage },
		loadData: async ({ actions, match }) => {
			const keyword = match.params.keyword || '';
			return actions.getPSPLandingPage(keyword);
		},
	},
	{
		path: '/storage-unit-size-guide/:keyword(5x5|5x10|5x15|10x10|10x15|10x20|10x25|10x30)-storage-unit(.html)?',
		exact: true,
		component: PSPPage,
		actions: { getPSPLandingPage },
		loadData: async ({ actions, match }) => {
			const keyword = match.params.keyword || '';
			return actions.getPSPLandingPage(keyword);
		},
	},
	{
		path: '/storage-101(.html)?',
		exact: true,
		component: PSPPage,
		actions: { getPSPLandingPage },
		keyword: 'self',
		loadData: ({ actions }) => {
			const keyword = 'self';
			return actions.getPSPLandingPage(keyword);
		},
	},
	{
		path: '/storage-with-electricity(.html)?',
		exact: true,
		component: PSPPage,
		actions: { getPSPLandingPage },
		keyword: 'electricity',
		loadData: ({ actions }) => {
			const keyword = 'electricity';
			return actions.getPSPLandingPage(keyword);
		},
	},
	{
		path: '/:state([A-Za-z-]+)-storage(.html)?',
		exact: true,
		component: StateLandingPage,
		actions: { getStateLandingPage },
		loadData: ({ actions, match }) =>
			actions.getStateLandingPage({ state: match.params.state }),
	},
	{
		path: '/moving-truck-rental(.html)?',
		exact: true,
		actions: { getMovingTruckPage },
		component: MovingTruckPage,
		loadData: (props) =>
			props.actions.getMovingTruckPage(props.queryParams),
	},
	{
		path: '/moving-truck-rental/:city([A-Za-z0-9-\\.]+)-:state([A-Za-z]{2})(.html)?',
		exact: true,
		actions: { getMovingTruckCityLandingPage },
		component: MovingTruckCLPPage,
		loadData: (props) =>
			props.actions.getMovingTruckCityLandingPage(props.match.params),
	},
	{
		path: '/reservation/confirm-:moveInStatus(.*move-in)/:confirmationCode([A-Za-z0-9]+)(.html)?',
		exact: true,
		component: MoveInConfirmStatusPage,
		actions: { getMoveInConfirmStatusPage },
		loadData: (props) =>
			props.actions.getMoveInConfirmStatusPage(
				props.match.params.confirmationCode,
				props.match.params.moveInStatus
			),
	},
	{
		path: '/tools/vehicle-length(.html)?',
		exact: true,
		component: VehicleLengthPage,
		actions: { vehicleLengthPageSuccess },
		loadData: (props) => props.actions.vehicleLengthPageSuccess(),
	},
	{
		path: '/paid/:paidPageUri?', // requires camelcase syntax to fire action & handle /paid/ or /paid/some-route-here dynamically
		component: PaidTemplatePage,
		actions: { getPaidTemplatePage },
		loadData: (props) =>
			props.actions.getPaidTemplatePage(
				props.queryParams,
				props.match.url
			),
	},
	{
		path: '/style-guide(.html)?',
		exact: true,
		component: StyleGuidePage,
		actions: { getHomepage },
		loadData: (props) => props.actions.getHomepage(),
	},
	{
		component: NewFourOhFourPage,
	},
];

export default function Routes() {
	return (
		<Switch>
			{staticRoutes.map((route, i) => (
				<SFRoute
					key={route.key || i}
					path={route.path}
					exact={route.exact}
					strict={route.strict}
					component={route.component}
					pageType={route.pageType}
					keyword={route.keyword}
				/>
			))}
		</Switch>
	);
}
